import { TranslateResult } from "vue-i18n";
import { LiveChatInvitationSubjectType } from "@scrile/api-provider/dist/api/LiveChatInvitationsProvider";
import { $t } from "@/lib/i18nHelpers";

export const liveNames: Record<string, string | TranslateResult> = {
  [LiveChatInvitationSubjectType.COLLAB]: $t("Collab Live"),
};
